import React from 'react';
import { useFormContext } from 'react-hook-form';
import { getRatingSet } from '../evaluation.constants';
import { FORM_FIELD } from '../../../ui/formTheme';

const EvaluationAutoFill = ({ duties = [], keyPrefix = "", selectedRole }) => {
    const { setValue } = useFormContext();
    const ratings = getRatingSet(selectedRole);

    return (
        <div>
            <label className={FORM_FIELD.label}>
                Auto-fill all ratings with:
            </label>
            <select
                key={keyPrefix} // Forces reset when key changes (e.g. page change)
                className={`${FORM_FIELD.control} ${FORM_FIELD.enabled} cursor-pointer`}
                onChange={(e) => {
                    const val = e.target.value;
                    if(val) {
                        // Auto-fill logic
                        duties.forEach(d => setValue(d.id, val));
                    }
                }}
            >
                <option value="">Select to auto-fill all ratings (optional)</option>
                {ratings.map((rating) => (
                    <option key={rating.value} value={rating.value}>
                        {rating.label}
                    </option>
                ))}
            </select>
            <p className="text-xs text-slate-500 mt-1">If selected, all rating fields will be automatically filled with this value</p>
        </div>
    );
};

export default EvaluationAutoFill;
